import * as React from "react";
import { SVGProps } from "react";
const SvgArrowUpDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m4.165 9.459 3.29-3.237a.783.783 0 0 1 1.093 0l3.29 3.237c.312.306.156.541-.325.541H4.49c-.494 0-.637-.235-.325-.541Z"
      fill="#9B9C9E"
    />
    <g clipPath="url(#arrow-up-down_svg__a)">
      <path
        d="m11.835 14.541-3.29 3.237a.783.783 0 0 1-1.093 0l-3.29-3.237c-.312-.306-.156-.541.325-.541h7.023c.494 0 .637.235.325.541Z"
        fill="#9B9C9E"
      />
    </g>
    <defs>
      <clipPath id="arrow-up-down_svg__a">
        <path fill="#fff" transform="translate(0 8)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowUpDown;
